// imported from @parcellab/react-use-umami and added types
const eventQueue: Array<{ event: string; payload?: Record<string, any> }> = []

export const registerUmamiScript = (
  url: string,
  websiteId: string,
  dataDomain: string,
  onLoad?: (...args: any[]) => any,
) => {
  if (!url || !websiteId) {
    console.warn('Umami: missing url or websiteId')
    return
  }
  const head = document.getElementsByTagName('head')[0]
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = url
  script.async = true
  script.defer = true
  script.setAttribute('data-auto-track', 'false')
  script.setAttribute('data-website-id', websiteId)
  if (dataDomain) {
    script.setAttribute('data-domains', dataDomain)
  }
  script.onload = () => {
    // Process the queue when Umami is loaded
    while (eventQueue.length > 0) {
      const { event, payload } = eventQueue.shift()!
      window.umami?.track((props) => ({
        ...props,
        name: event,
        payload,
      }))
    }
    if (onLoad) {
      onLoad()
    }
  }
  head.appendChild(script)
}

export const umamiTrackEvent = (event: string, payload?: Record<string, any>) => {
  if (typeof window.umami !== 'undefined') {
    window.umami.track((props) => ({ ...props, name: event, payload }))
  } else {
    eventQueue.push({ event, payload })
  }
}
